import { User } from "@xbox/social-core";

// Predefined list of authorized xuids for official club creation
// For detailed information about these privileged accounts, see the "Privileged XUIDs" section in README.md
const AUTHORIZED_XUIDS_FOR_OFFICIAL_CLUB_CREATION: string[] = [
    "2535410295836475",
    "2535455888700180"
];

export const IsAuthorizedForOfficialClubCreation = (user?: User): boolean => {
    // If no user is logged in, return false
    if (!user) {
        return false;
    }

    // Check if the current user's xuid is in the authorized list
    return AUTHORIZED_XUIDS_FOR_OFFICIAL_CLUB_CREATION.includes(user.xuid);
};
